import { MenuItem } from '@app/core/models';
import { RoleName } from '@app/shared/enums/user.enum';
import { RoleFunctionName } from '@app/core/enums/role-function-name.enum';

export const menuItems: MenuItem[] = [
  {
    title: 'Main',
    iconSrc: '../../assets/svg/dashboard.svg',
    routerLink: '/main'
  },
  // {
  //   title: 'Consulting',
  //   iconSrc: '../../assets/svg/chart.svg',
  //   routerLink: '/consulting',
  //   subMenu: [
  //     {
  //       title: 'As is',
  //       iconSrc: '../../assets/svg/consulting.svg',
  //       isRouting: true,
  //       routerLink: '/consulting/as-is'
  //     }
  //   ]
  // },
  {
    title: 'Notifications',
    iconSrc: '../../assets/svg/messages-menu.svg',
    routerLink: '/notifications'
  },
  {
    title: 'Tasks',
    iconSrc: '../../assets/svg/tasks.svg',
    routerLink: '/tasks',
    requiredRoles: [RoleName.Approver, RoleName.Admin],
    requiredFunctions: [RoleFunctionName.ApprovalViewTask],
    subMenu: [
      {
        title: 'Approval Tasks',
        iconSrc: '../../assets/svg/tasks.svg',
        routerLink: '/tasks/approval-tasks',
        isRouting: true,
        requiredRoles: [RoleName.Approver, RoleName.Admin],
        requiredFunctions: [RoleFunctionName.ApprovalViewTask]
      }
    ]
  },
  {
    title: 'Analytics',
    iconSrc: '../../assets/svg/chart.svg',
    routerLink: '/analytics',
    requiredRoles: [RoleName.Buyer, RoleName.Admin],
    subMenu: [
      {
        title: 'Main indicators',
        iconSrc: '../../assets/svg/main-indicators.svg',
        isRouting: true,
        routerLink: '/analytics/main-indicators'
      },
      {
        title: 'Analytics of counterparties',
        iconSrc: '../../assets/svg/main-indicators.svg',
        isRouting: true,
        routerLink: '/analytics/analytics-of-counterparties'
      },
      {
        title: 'Corporate analytics',
        iconSrc: '../../assets/svg/main-indicators.svg',
        isRouting: true,
        routerLink: '/analytics/corporate-analytics'
      }
    ]
  },
  {
    title: 'Procurement',
    iconSrc: '../../assets/svg/cart.svg',
    routerLink: '/procurement',
    requiredRoles: [
      RoleName.Buyer,
      RoleName.Supplier,
      RoleName.Approver,
      RoleName.Admin
    ],
    subMenu: [
      // {
      //   title: 'Analytics',
      //   iconSrc: '../../assets/svg/chart_data.svg',
      //   requiredRole: RoleName.Buyer,
      //   subGroup: []
      // },
      {
        title: 'Planning',
        iconSrc: '../../assets/svg/article.svg',
        requiredRoles: [RoleName.Buyer, RoleName.Admin],
        subGroup: [
          { title: 'Budgeting', routerLink: '/procurement/planning/budgeting' },
          {
            title: 'Forecasting',
            routerLink: '/procurement/planning/forecasting'
          },
          {
            title: 'Procurement plan',
            routerLink: '/procurement/planning/container-plan'
          },
          {
            title: 'Procurement calendar',
            routerLink: '/procurement/planning/container-calendar'
          }
        ]
      },
      {
        title: 'PR',
        iconSrc: '../../../assets/svg/article.svg',
        requiredRoles: [RoleName.Buyer, RoleName.Approver, RoleName.Admin],
        requiredFunctions: [
          RoleFunctionName.PurchaseRequestViewOwn,
          RoleFunctionName.PurchaseRequestViewAll
        ],
        subGroup: [
          {
            title: 'PR List',
            routerLink: '/procurement/pr/pr-list',
            requiredRoles: [RoleName.Buyer, RoleName.Approver, RoleName.Admin],
            requiredFunctions: [
              RoleFunctionName.PurchaseRequestViewOwn,
              RoleFunctionName.PurchaseRequestViewAll
            ]
          },
          {
            title: 'Item management',
            routerLink: '/procurement/pr/item-management',
            requiredRoles: [RoleName.Buyer, RoleName.Admin],
            requiredFunctions: [
              RoleFunctionName.ItemsView,
              RoleFunctionName.ItemsEdit
            ]
          },
          // {
          //   title: 'AI - Purchasing',
          //   routerLink: '/procurement/pr/ai-purchasing'
          // },
          {
            title: 'Requests without tender',
            routerLink: '/procurement/pr/requests-without-tender'
          }
        ]
      },
      {
        title: "Supplier's office",
        iconSrc: '../../../assets/svg/profile.svg',
        requiredRoles: [RoleName.Supplier],
        requiredFunctions: [RoleFunctionName.ProceduresParticipate],
        subGroup: [
          {
            title: 'PROCUREMENT_LIST',
            routerLink: '/procurement/suppliers-office/procurement-list',
            requiredFunctions: [RoleFunctionName.ProceduresParticipate]
          }
        ]
      },
      {
        title: 'Tender/Auction',
        iconSrc: '../../../assets/svg/profile.svg',
        requiredRoles: [RoleName.Buyer, RoleName.Admin],
        requiredFunctions: [
          RoleFunctionName.ProceduresViewOwn,
          RoleFunctionName.ProceduresViewAll
        ],
        subGroup: [
          {
            title: 'Tender Journal',
            routerLink: '/procurement/tender-auction/tender-journal',
            requiredFunctions: [
              RoleFunctionName.ProceduresViewOwn,
              RoleFunctionName.ProceduresViewAll
            ]
          },
          // {
          //   title: 'Tender  Processor',
          //   routerLink: '/procurement/tender-auction/tender-processor',
          //   requiredRole: RoleName.Buyer
          // },
          // {
          //   title: 'AI Help',
          //   routerLink: '/procurement/tender-auction/ai-help',
          //   requiredRole: RoleName.Buyer
          // },
          {
            title: 'Experts',
            routerLink: '/procurement/tender-auction/experts',
            requiredRoles: [RoleName.Buyer, RoleName.Admin]
          }
        ]
      },
      {
        title: 'Supplier management',
        iconSrc: '../../../assets/svg/article.svg',
        requiredRoles: [RoleName.Buyer, RoleName.Admin],
        requiredFunctions: [
          RoleFunctionName.SuppliersView,
          RoleFunctionName.SuppliersEdit
        ],
        subGroup: [
          {
            title: 'List of Suppliers',
            routerLink: '/procurement/supplier-management/suppliers-list'
          },
          {
            title: 'Journal Supplier Audit',
            routerLink:
              '/procurement/supplier-management/journal-supplier-audit'
          },
          {
            title: 'Supplier Evaluation',
            routerLink: '/procurement/supplier-management/supplier-evaluation'
          },
          {
            title: 'Supplier risk assessment',
            routerLink:
              '/procurement/supplier-management/supplier-risk-assessment'
          }
        ]
      }
    ]
  },
  // {
  //   title: 'Sales',
  //   iconSrc: '../../assets/svg/company.svg',
  //   routerLink: '/sales',
  //   requiredRoles: [RoleName.Buyer]
  // },
  {
    title: 'Documents',
    iconSrc: '../../assets/svg/documents.svg',
    routerLink: '/commercial-documents',
    requiredRoles: [RoleName.Buyer, RoleName.Approver, RoleName.Admin],
    requiredFunctions: [
      RoleFunctionName.AgreementsViewOwn,
      RoleFunctionName.AgreementsViewAll
    ],
    subMenu: [
      {
        title: 'Agreements',
        iconSrc: '../../../assets/svg/article.svg',
        subGroup: [
          {
            title: 'Agreement list',
            routerLink: '/commercial-documents/agreements/agreement-list'
          },
          {
            title: 'Item management',
            routerLink: '/commercial-documents/agreements/item-management'
          },
          {
            title: 'Create New',
            routerLink: '/commercial-documents/agreements/create-new',
            requiredRoles: [RoleName.Admin]
          },
          {
            title: 'From Template',
            routerLink: '/commercial-documents/agreements/from-template',
            requiredRoles: [RoleName.Admin]
          },
          {
            title: 'Journal of Treaties',
            routerLink: '/commercial-documents/agreements/treaties-journal',
            requiredRoles: [RoleName.Admin]
          },
          {
            title: 'Experts',
            routerLink: '/commercial-documents/agreements/experts',
            requiredRoles: [RoleName.Admin]
          }
        ]
      },
      {
        title: 'Orders',
        iconSrc: '../../../assets/svg/article.svg',
        subGroup: [
          {
            title: 'Order List',
            routerLink: '/commercial-documents/orders/order-list'
          }
        ]
      },
      {
        title: 'Receipts',
        iconSrc: '../../../assets/svg/article.svg',
        subGroup: [
          {
            title: 'Receipt list',
            routerLink: '/commercial-documents/receipts/receipt-list'
          }
        ]
      }
    ]
  },

  {
    title: 'Marketplace',
    iconSrc: '../../assets/svg/storefront.svg',
    routerLink: '/marketplace',
    requiredRoles: [RoleName.Buyer, RoleName.Admin]
  },
  {
    title: 'Company Profile',
    iconSrc: '../../assets/svg/company.svg',
    routerLink: '/company',
    subMenu: [
      {
        title: 'Company details',
        iconSrc: '../../assets/svg/mycompany.svg',
        isRouting: true,
        routerLink: '/company/details',
        requiredFunctions: [
          RoleFunctionName.ProfileView,
          RoleFunctionName.ProfileEdit
        ]
      },
      // {
      //   title: 'Documents',
      //   iconSrc: '../../assets/svg/document.svg',
      //   isRouting: true,
      //   routerLink: '/company/documents'
      // },
      {
        title: 'Staff',
        iconSrc:
          '../../assets/svg/administration-menu-icons/roles-and-access-settings.svg',
        isRouting: true,
        routerLink: '/company/staff',
        requiredFunctions: [
          RoleFunctionName.StaffView,
          RoleFunctionName.StaffEdit
        ]
      }
      // {
      //   title: 'Dictionaries',
      //   iconSrc: '../../assets/svg/dictionaries.svg',
      //   subGroup: [
      //     { title: 'Categories', routerLink: '/company/categories' },
      //     { title: 'Products', routerLink: '/company/products' },
      //     { title: 'SKUs', routerLink: '/company/sku' }
      //   ]
      // },
      // {
      //   title: 'Catalogues',
      //   iconSrc: '../../../assets/svg/catalogues.svg',
      //   subGroup: [{ title: 'Pricelists', routerLink: '/company/price-lists' }]
      // }
    ]
  },
  // {
  //   title: 'Compliance',
  //   iconSrc: '../../assets/svg/compliance.svg',
  //   routerLink: '/compliance'
  // },
  {
    title: 'Administration',
    iconSrc: '../../assets/svg/administration.svg',
    routerLink: '/administration',
    requiredRoles: [RoleName.Admin],
    requiredFunctions: [
      RoleFunctionName.AdminView,
      RoleFunctionName.AdminEdit
    ],
    subMenu: [
      {
        title: 'General settings',
        iconSrc: '../../assets/svg/mycompany.svg',
        subGroup: [
          {
            title: 'Localization',
            routerLink: 'administration/general-settings/localization'
          }
        ]
      },
      {
        title: 'Directory constructor',
        iconSrc: '../../assets/svg/category.svg',
        subGroup: [
          {
            title: 'Directories catalog',
            routerLink:
              'administration/directories-constructor/directories-catalog'
          },
          {
            title: 'Template Criteria',
            routerLink:
              'administration/directories-constructor/criteria-group-template'
          },
          {
            title: 'Stage Types',
            routerLink: 'administration/directories-constructor/stage-types'
          },
          {
            title: 'Attributes',
            routerLink: 'administration/directories-constructor/attributes'
          },
          {
            title: 'Criteria Groups',
            routerLink: 'administration/directories-constructor/criteria-groups'
          },
          {
            title: 'Nomenclature',
            routerLink: 'administration/directories-constructor/nomenclature'
          },
          {
            title: 'Nomenclature Parameters',
            routerLink:
              'administration/directories-constructor/nomenclature-parameters'
          }
        ]
      },
      {
        title: 'Directories',
        iconSrc: '../../assets/svg/directory.svg',
        subGroup: [
          {
            title: 'Banks',
            routerLink: 'administration/directory/banks'
          },
          {
            title: 'Ownership types',
            routerLink: 'administration/directory/ownership-types'
          },
          {
            title: 'Countries',
            routerLink: 'administration/directory/countries'
          },
          {
            title: 'Divisions',
            routerLink: 'administration/directory/divisions'
          },
          {
            title: 'Languages',
            routerLink: 'administration/directory/localization/languages'
          },
          {
            title: 'Criteria',
            routerLink: 'administration/criteria'
          },
          {
            title: 'Process Template',
            routerLink: 'administration/process-template'
          }
        ]
      },
      {
        title: 'Roles and access settings',
        iconSrc:
          '/assets/svg/administration-menu-icons/roles-and-access-settings.svg',
        requiredFunctions: [RoleFunctionName.AdminEdit],
        subGroup: [
          {
            title: 'Roles and groups',
            routerLink:
              'administration/roles-and-access-settings/roles-and-groups'
          },
          {
            title: 'Access settings',
            routerLink:
              'administration/roles-and-access-settings/access-settings'
          }
        ]
      },
      {
        title: 'Approval',
        iconSrc: '/assets/svg/administration-menu-icons/approval.svg',
        requiredFunctions: [
          RoleFunctionName.ApprovalManageRoutes,
          RoleFunctionName.ApprovalManageGroups
        ],
        subGroup: [
          {
            title: 'Approval groups',
            routerLink: 'administration/approval/approval-groups'
          },
          {
            title: 'Approval templates',
            routerLink: 'administration/approval/approval-templates'
          }
        ]
      },
      {
        title: 'ORCHESTRATION',
        iconSrc: '../../assets/svg/category.svg',
        subGroup: [
          {
            title: 'ORCHESTRATION_CONSTRUCTOR',
            routerLink:
              'http://neolink-elsa-workflows.westeurope.azurecontainer.io',
            isExternalLink: true
          }
        ]
      },
      {
        title: 'Process designer',
        iconSrc: '/assets/img/creative-process.png',
        subGroup: [
          {
            title: 'Constructor process (demo)',
            routerLink: '/administration/constructor-process'
          },
          {
            title: 'Constructor diagram (demo)',
            routerLink: '/administration/constructor-diagram'
          }
        ]
      }
    ]
  }
];
